import styled, { css } from "styled-components"
import { type ButtonProps } from "./Button"

const sizeButton = {
  small: css`
    padding: 0.5rem 1rem 0.5rem 1rem;
    height: 40px;
  `,
  medium: css``,
  full: css`
    width: 100%;
  `,
}

export const ButtonDefault = styled.div<ButtonProps>`
  --icon-color: #333333;
  display: inline-flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 1rem 2rem 1rem 2rem;
  height: 56px;
  font-size: 14px;
  line-height: 100%;
  font-weight: 600;
  border: 1px solid;
  border-radius: 0.25rem;
  color: #333333;
  border-color: #333333;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  &:not(:disabled):hover {
    opacity: 0.7;
  }

  ${({ size }) => size && sizeButton[size]}

  ${({ palette }) => palette && css`
    background-color: ${palette.bgColor || '#007bff'};
    border-color: ${palette.borderColor || palette.bgColor || '#007bff'};
    color: ${palette.textColor || '#ffffff'};
  `}

  &.styleguide {
    border-radius: var(--design-button-border-radius, 0.25rem);
    border-width: var(--design-button-border-width, 1px);
    border-style: solid;

  ${({ palette }) => css`
    background-color: ${palette?.bgColor || "var(--buttons-background, #007bff)"};
    border-color: ${palette?.borderColor || "var(--buttons-border, #007bff)"};
    color: ${palette?.textColor || "var(--buttons-text, #ffffff)"};
    --icon-color: ${palette?.textColor || "var(--buttons-text, #ffffff)"};
  `}
  }
`;